var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rh4jcna1gb",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.615686 0 0 0 0 0.639216 0 0 0 0 0.650980 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "t2yy7nbgda",
    d: "M0 0H270V270H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1597 -441) translate(1597 441)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b731uoebcc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t2yy7nbgda"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F9",
    xlinkHref: "#t2yy7nbgda"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#rh4jcna1gb)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b731uoebcc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L270 0 270 270 0 270z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M136 161c30.94 0 56-25.06 56-56s-25.06-56-56-56-56 25.06-56 56 25.06 56 56 56zm-.5 27C98.287 188 24 206.76 24 244v28h223v-28c0-37.24-74.287-56-111.5-56z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFallback);
export default __webpack_public_path__ + "static/media/avatar-fallback.a27d58e1316b7c5ad8cd629c9262cf83.svg";
export { ForwardRef as ReactComponent };